import React from 'react';
import PropTypes from 'prop-types';
import { Card, Spinner } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';

/**
 * Reusable chat message list component used by both the full Assistant page
 * and the floating ChatWidget.
 */
export default function ChatMessages({
    messages,
    loading,
    loadingLabel,
    messagesEndRef,
}) {
    return (
        <>
            {messages.map((message) => (
                <div
                    key={message.id}
                    className={`message ${message.sender === 'user' ? 'user-message' : 'bot-message'}`}
                >
                    <Card
                        className={`message-card border-0 ${
                            message.sender === 'user'
                                ? 'bg-primary text-white'
                                : message.isError
                                  ? 'bg-danger-subtle'
                                  : 'bg-light'
                        }`}
                    >
                        <Card.Body className="p-3">
                            {message.sender === 'bot' ? (
                                <ReactMarkdown>{message.text}</ReactMarkdown>
                            ) : (
                                message.text
                            )}
                        </Card.Body>
                    </Card>
                    <small className="text-muted">
                        {message.timestamp
                            ? message.timestamp.toLocaleTimeString([], {
                                  hour: '2-digit',
                                  minute: '2-digit',
                              })
                            : ''}
                    </small>
                </div>
            ))}
            {loading && (
                <div className="message bot-message">
                    <Card className="message-card border-0 bg-light">
                        <Card.Body className="p-3">
                            <Spinner
                                animation="border"
                                size="sm"
                                className="me-2"
                            />
                            {loadingLabel || 'Thinking...'}
                        </Card.Body>
                    </Card>
                </div>
            )}
            <div ref={messagesEndRef} />
        </>
    );
}

ChatMessages.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            sender: PropTypes.string.isRequired,
            timestamp: PropTypes.instanceOf(Date),
            isError: PropTypes.bool,
        })
    ).isRequired,
    loading: PropTypes.bool,
    loadingLabel: PropTypes.string,
    messagesEndRef: PropTypes.object,
};
